import { CircularProgressbar, buildStyles } from "react-circular-progressbar";

const SummaryComponent = (props) => {

    const {
        total_percentage,
        total_assigned,
        total_completed,
        week_progress,
        check,
        isLp,
        courseOrVideo
    } = props

    const search = window.location.search;
    const params = new URLSearchParams(search);
    const isAgent = params.get("isAgent");

    return (
        <div className="row">
            <div className="col-md-12">
                <div className="reports-chart graph-box-learnong shadow-box-report">
                    <div className="chart-heading-report">
                        Summary
                    </div>
                    <div className="row">
                        <div className="col-md-5 col-xl-4">
                            <div className="graph-box-learnong">
                                <div
                                    className="circularProgress"
                                    style={{
                                        width: 150,
                                        height: 150,
                                        position: "relative",
                                    }}
                                >
                                    <CircularProgressbar
                                        value={total_assigned === 0 ? 0 : total_percentage ? total_percentage : 0}
                                        strokeWidth={25}

                                        styles={buildStyles({
                                            pathColor: "#6941C6", //FF9700=yellow
                                            trailColor: "#EBEBEB",
                                            strokeLinecap: 'butt',
                                        })}
                                    />
                                    <div
                                        style={{
                                            position: "absolute",
                                            top: "0",
                                            width: "150px",
                                            bottom: "0",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            textAlign: "center",

                                        }}
                                    >
                                        {true ? (
                                            <>
                                                <strong
                                                    style={{ color: "black" }}
                                                >{`${total_assigned === 0 ? 0 : total_percentage ? total_percentage : 0}%`}</strong>

                                            </>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                </div>
                                <div className="complints-sub-text">
                                    Overall {check ? isLp ? "Onboarding" : "Compliance" : isLp ? "Learning Path" : "Learning Progress"} %
                                </div>
                            </div>

                        </div>
                        <div className="col-md-7 col-xl-8">
                            <div className="graph-box-learnong">
                                <div className="proglefttext">{check ? isLp ? "Onboarding" : "Compliance Courses" : isLp ? "Learning Path" : courseOrVideo ? "Learning Progress Videos" : "Learning Progress Courses"}</div>
                                <div className="d-flex gap-5 justify-content-center">
                                    <div className="count-col">
                                        <div className="coluns-report-rsp">
                                            <strong>{total_completed}/</strong>{total_assigned}
                                        </div>
                                        <div className="complints-sub-text">
                                            {check ? isLp ? "Onboarding Completed" : "Course(s) Completed" : isLp ? "Learning Path Completed" : courseOrVideo ?  "Video(s) Completed" : "Courses(s) Completed"}
                                        </div>
                                    </div>
                                    <div className="count-col">
                                        <div className={Number(week_progress) < 0 ? "coluns-report-rsp-percent minus-percent" : "coluns-report-rsp-percent"}>
                                            {(Number(week_progress).toString().length > 4 ? Number(week_progress).toFixed(2) : week_progress)}<small>%</small>
                                        </div>
                                        <div className="complints-sub-text">
                                            From Last Week
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SummaryComponent